
import * as ActionTypes from 'constants';

export const toggleInitFlag = val => ({ type : ActionTypes.TOGGLE_INIT_FLAG, payload : val });
export const toggleShowSidebarContainer = val => ({ type : ActionTypes.TOGGLE_SHOW_SIDEBAR_CONTAINER, payload : val });
export const toggleMainMenu = bool => ({ type: ActionTypes.TOGGLE_MAIN_MENU, payload: { bool } });
export const toggleShowTasksSidebar = bool => ({ type: ActionTypes.TOGGLE_SHOW_TASKS_SIDEBAR, payload: bool });



// WEBPACK FOOTER //
// ./src/common/actions/ui.js